module.exports = __webpack_public_path__ + "img/img_23_brand_retail@3x.779c4e0f.png";